/* tslint:disable */
/* eslint-disable */
/**
 * Resource server API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { PaymentRefundPercentage } from '../model';
/**
 * PaymentRefundControllerApi - axios parameter creator
 * @export
 */
export const PaymentRefundControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} visitId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentRefundPercentageLimit: async (visitId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visitId' is not null or undefined
            assertParamExists('getCurrentRefundPercentageLimit', 'visitId', visitId)
            const localVarPath = `/api/payment-refund-restrictions/{visitId}`
                .replace(`{${"visitId"}}`, encodeURIComponent(String(visitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PaymentRefundControllerApi - functional programming interface
 * @export
 */
export const PaymentRefundControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PaymentRefundControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} visitId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrentRefundPercentageLimit(visitId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<PaymentRefundPercentage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrentRefundPercentageLimit(visitId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PaymentRefundControllerApi - factory interface
 * @export
 */
export const PaymentRefundControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PaymentRefundControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} visitId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentRefundPercentageLimit(visitId: number, options?: any): Promise<PaymentRefundPercentage> {
            return localVarFp.getCurrentRefundPercentageLimit(visitId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PaymentRefundControllerApi - object-oriented interface
 * @export
 * @class PaymentRefundControllerApi
 * @extends {BaseAPI}
 */
export class PaymentRefundControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} visitId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentRefundControllerApi
     */
    public getCurrentRefundPercentageLimit(visitId: number, options?: AxiosRequestConfig) {
        return PaymentRefundControllerApiFp(this.configuration).getCurrentRefundPercentageLimit(visitId, options).then((request) => request(this.axios, this.basePath));
    }
}
